import { render, staticRenderFns } from "./drugform.vue?vue&type=template&id=49c3ea08&"
import script from "./drugform.vue?vue&type=script&lang=js&"
export * from "./drugform.vue?vue&type=script&lang=js&"
import style0 from "./drugform.vue?vue&type=style&index=0&id=49c3ea08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports